import { createAction, props } from '@ngrx/store';
import { IMenuItem } from './../interfaces/menu';


export const GetMenuAction = createAction(
  '[Menu] Get Menu'
);

export const SetMenuAction = createAction(
  '[Menu] Set Menu',
  props<{ menu: IMenuItem[] }>());

export const GetAdminMenuAction = createAction(
  '[Menu] Get Admin Menu'
);

export const SetAdminMenuAction = createAction(
  '[Menu] Set Admin Menu',
  props<{ adminMenu: IMenuItem[] }>());

export const MenuActions = {
  GetMenuAction,
  SetMenuAction,
  GetAdminMenuAction,
  SetAdminMenuAction
};
